import { render } from "./VUEComponenteGraficoAccelerometri.vue?vue&type=template&id=c648383c"
import script from "./VUEComponenteGraficoAccelerometri.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoAccelerometri.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__